module.exports = "<svg width=\"14\" height=\"18\" viewBox=\"0 0 14 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M1 16V4h12v12c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2zm2.46-7.12L5.59 11l-2.12 2.12 1.41 1.41L7 12.41l2.12 2.12 1.41-1.41L8.41 11l2.12-2.12-1.41-1.41L7 9.59 4.87 7.47 3.46 8.88zM10.5 1l-1-1h-5l-1 1H0v2h14V1\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/delete.svg
// module id = 815
// module chunks = 0